export default __webpack_public_path__ + "static/media/placeholder.a7f6375d.svg";